import * as React from "react";

const Share = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"10%"}
    height={"10%"}
    style={{
      maxWidth: 64,
      maxHeight: 64,
      minWidth: 60,
      minHeight: 40
    }}
    viewBox="0 0 78 64"
    fill="none"
    {...props}>
    <path
    d="M15 60
    C15 38 28 24 48 24
    L48 14
    L63 31
    L48 48
    L48 38
    C25 38 15 46 15 60"
    stroke="#555"
    strokeWidth={1}
    strokeLinecap="round"
    strokeLinejoin="round"
    />
    </svg>
  );
};

export default Share;
